import type { BlokProps } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import type { SbBlokData } from "@storyblok/react/rsc";
import { storyblokEditable } from "@storyblok/react/rsc";

import { AccordionRoot } from "@/components/ui/Accordion";
import BlokWrap from "@/components/ui/BlokWrap";
import type { AccordionStoryblok } from "@/generated/sb/sb-types";
import AccordionItemBlok from "./AccordionItem";
import styles from "./index.module.css";

const Accordion = ({
  blok,
  preview,
  className,
  firstOpen,
}: BlokProps<AccordionStoryblok> & {
  className?: string;
  firstOpen?: boolean;
}) => {
  return (
    <BlokWrap
      {...storyblokEditable(blok as unknown as SbBlokData)}
      animated="fadeY"
      data-layout={"page"}
      className={`hero-container ${styles.root}`}
    >
      <div className={clsx(styles.wrapper, className)}>
        {blok.title && (
          <div className={styles.title}>
            <h2>{blok.title}</h2>
          </div>
        )}
        <AccordionRoot>
          {blok.items &&
            blok.items.map((item, i) => (
              <AccordionItemBlok
                item={item}
                key={item._uid}
                preview={preview}
                open={i === 0}
              />
            ))}
        </AccordionRoot>
      </div>
    </BlokWrap>
  );
};

export default Accordion;
